import React, { useState, useEffect } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Typography,
  Grid,
  Button,
  TextField,
  InputBase,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { store } from "../../../../helpers/store";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
  },
  searchTextfield: {
    width: "100%",
  },
  tertiaryButton:{
    padding: "0 3rem",
    backgroundColor: theme.palette.eTertiary.base + " !important",
    textTransform: "none",
    color:theme.palette.eWhite.base,
    height:"40px",
    borderRadius:"0px"
  },
}));

export default function SearchBar(props) {
  const searchDetails = useSelector((state) => state.searchResults);
  const [keywordInURL,setKeywordInURL] = useState(new URLSearchParams(window.location.search).get("q"));
  const labels = useSelector((state) => state?.labels?.data?.getLabels?.SEARCH);
  const { keyword } = searchDetails;
  const classes = useStyles();
  const [Keyword, setKeyword] = useState(keywordInURL ? keywordInURL : keyword);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setKeyword(e.target.value);
    setKeywordInURL(e.target.value);
  };

  const handleDefaultSubmit = (e) => {
    e.preventDefault();
    let word = Keyword?.split("");
    if (word?.length >= 3) {
      setError(false);
      props.submitHandler(Keyword);
      store.getState().snackbar = true;
    } else {
      setError(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // props.handleSubmitSearch(Keyword);

    let word = Keyword?.split("");
    if (word?.length >= 3) {
      setError(false);
      props.handleSubmitSearch(Keyword);
      store.getState().snackbar = true;
    } else {
      setError(true);
    }
  };

  useEffect(() => {}, [searchDetails.keyword]);

  useEffect(() => {
    setKeyword(keyword);
  }, [keyword]);

  return (
    <div style={{paddingRight:"10px"}}>
      <form className={classes.root} onSubmit={handleSubmit}>
        <TextField
          error={error}
          fullWidth
          size="small"
          variant="outlined"
          id="search-Keyword"
          name="Keyword"
          autoComplete="off"
          value={Keyword}
          onChange={handleChange}
          className={classes.searchTextfield}
          helperText={error ? labels?.SEARCH_WARNING : null}
          placeholder={
            props.mobileScreen
              ? labels?.SEARCH_MOBILE_PLACEHOLDER
              : labels?.SEARCH_AUTH_PLACEHOLDER
          }
          InputProps={{
            style: {
              width: "100%",
              height: "40px",
              borderRadius:"0px"
            },
          }}
        />
    
        <Button
          type="submit"
          variant="contained"
          onClick={props.isDefault ? handleDefaultSubmit : handleSubmit}
          className={classes.tertiaryButton}
        >
          <b>{labels?.SEARCH_BUTTON}</b>
        </Button>
      </form>
    </div>
  );
}
